import { z } from "zod";
import { type IntlShape } from "react-intl";

const cartonPropertyGroupStatuses = ["Normal", "Surge", "Stop"] as const;
export const cartonPropertyGroupStatusSchema = z.enum(cartonPropertyGroupStatuses);
export type CartonPropertyGroupStatus = z.infer<typeof cartonPropertyGroupStatusSchema>;

export const cartonPropertyGroupConfigurationSchema = (intl: IntlShape) =>
	z.object({
		alias: z
			.string(intl.formatMessage({ id: "Alias needs to be a string", defaultMessage: "Alias needs to be a string" }))
			.trim()
			.nonempty(intl.formatMessage({ id: "Alias can not be empty", defaultMessage: "Alias can not be empty" })),
		ratio: z.number(),
		assignedToProductionGroups: z.array(z.string()),
	});

export type CartonPropertyGroupConfiguration = z.infer<ReturnType<typeof cartonPropertyGroupConfigurationSchema>>;

export const cartonPropertyGroupSchema = (intl: IntlShape) =>
	cartonPropertyGroupConfigurationSchema(intl).extend({
		id: z
			.string(intl.formatMessage({ id: "Id needs to be a string", defaultMessage: "Id needs to be a string" }))
			.trim()
			.nonempty(intl.formatMessage({ id: "Id can not be empty", defaultMessage: "Id can not be empty" })),
		tenantId: z
			.string(
				intl.formatMessage({ id: "TenantId needs to be a string", defaultMessage: "TenantId needs to be a string" }),
			)
			.trim()
			.nonempty(intl.formatMessage({ id: "TenantId can not be empty", defaultMessage: "TenantId can not be empty" })),
		status: cartonPropertyGroupStatusSchema,
		remainingSurgeCount: z.number(),
	});

export type CartonPropertyGroup = z.infer<ReturnType<typeof cartonPropertyGroupSchema>>;
